import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';
import Form from 'components/Form';

import { useErrorHandler } from 'lib';
import { CategoryEditFormMutation } from '__generated__/CategoryEditFormMutation.graphql';
import { CategoryEditForm_category$key } from '__generated__/CategoryEditForm_category.graphql';

type FormValues = {
  name: string;
};

type Props = {
  category: CategoryEditForm_category$key;
};

const CategoryEditForm: FC<Props> = ({ category: label }) => {
  const errorHandler = useErrorHandler();

  const { id, name } = useFragment(
    graphql`
      fragment CategoryEditForm_category on Category {
        id
        name
      }
    `,
    label
  );

  const [update, loading] = useMutation<CategoryEditFormMutation>(graphql`
    mutation CategoryEditFormMutation($id: ID!, $input: UpdateCategoryInput!) {
      updateCategory(id: $id, input: $input) {
        ...CategoryEditForm_category
        ...EntitySidebar_entity
      }
    }
  `);

  const initial = {
    name: name ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: { id, input },
        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={loading}>
        <AccordionController id="categoryEdit">
          <Section id="main" title="Bendra informacija">
            <Stack spacing={4}>
              <TextField autoFocus name="name" label="Pavadinimas" fullWidth />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default CategoryEditForm;
